/**
 * defa.routers.UnitRouter
 * The Router for the UnitController, all front end urls starting with /devices/.
 * @version 1.2.0
 */
const UnitRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'devices(/)'                           : 'showUnitList',
		'devices/new(/)'                       : 'showUnitNativeChoice',
		'devices/bluetooth(/)'                 : 'showUnitBluetooth',
		'devices/search(/)'                    : 'showUnitSearch',
		'devices/help(/)'                      : 'showUnitHelp',
		'devices/installed(/)'                 : 'showUnitsInstalled', // this is for selecting installer
		'devices/installed/:installer/:page(/)': 'showUnitsInstalled', // this is for viewing units
		'devices/:id/delete(/)'                : 'showUnitDelete',
		'devices/:id/details(/)'               : 'showUnitDetails',
		'devices/:id/test(/)'                  : 'showUnitTest',
		'devices/:id/testresults(/)'           : 'showUnitTestResults',
		'devices/:id/complaint(/)'             : 'showUnitComplaint',
		'devices/:id/alias(/)'                 : 'showUnitAlias',
		'devices/:id/alarm(/)'                 : 'showUnitAlarm',
		'devices/:id/notes(/)'                 : 'showUnitNotes',
		'devices/:id/location(/)'              : 'showUnitLocation',
		'devices/:id/vehicle(/)'               : 'showUnitVehicle',
		'devices/:id/reset(/)'                 : 'showUnitReset',
		'devices/:id/control(/)'               : 'showUnitControl',
		'devices/:id/control/:sub(/)'          : 'showUnitControl',
		'devices/:id/control/:sub/:subId(/)'   : 'showUnitControl',
		// we can add devices/:id/control/warmup etc as well...?
		
		'devices/:id/install(/)'                       : 'showUnitInstall',
		'devices/:id/install/:context/:email(/)'       : 'showUnitInstall',
		'devices/:id/install/:context/:email/:token(/)': 'showUnitWithToken',
		
		// haxx: !TODO: Remove haxx!
		//'map/': 'showUnitList',
		
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default UnitRouter;
